"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignIn = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable @typescript-eslint/no-use-before-define */
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var yup = __importStar(require("yup"));
var atoms_1 = require("../../atoms");
var Button_1 = require("../../atoms/Button");
var Text_1 = require("../../atoms/Text");
var TextField_1 = require("../../atoms/TextField");
var styles_1 = __importDefault(require("./styles"));
var SignIn = function (_a) {
    var onSubmit = _a.onSubmit, _b = _a.forgottenPassword, forgottenPassword = _b === void 0 ? function () { } : _b, _c = _a.initialUsername, initialUsername = _c === void 0 ? '' : _c, _d = _a.title, title = _d === void 0 ? 'Sign in' : _d, subtitle = _a.subtitle, _e = _a.rememberMeText, rememberMeText = _e === void 0 ? 'Remember me' : _e, _f = _a.forgottenPasswordText, forgottenPasswordText = _f === void 0 ? 'Forgot Password' : _f, _g = _a.remember, remember = _g === void 0 ? false : _g, footerText = _a.footerText, error = _a.error, icon = _a.icon, _h = _a.loading, loading = _h === void 0 ? false : _h;
    var classes = (0, styles_1.default)();
    var _j = (0, react_1.useState)(''), emailValidationError = _j[0], setEmailValidationError = _j[1];
    var _k = (0, react_1.useState)({
        username: initialUsername,
        password: '',
        remember: remember,
    }), state = _k[0], setState = _k[1];
    var handleCheck = function (event) {
        var checked = event.target.checked;
        setState(__assign(__assign({}, state), { remember: checked }));
    };
    var handleSubmit = function () { return !emailValidationError && onSubmit(state); };
    var username = state.username;
    (0, react_1.useEffect)(function () {
        yup
            .object()
            .shape({
            username: yup.string().email('Email address must be a valid email'),
        })
            .validate({ username: username })
            .then(function () { return setEmailValidationError(''); })
            .catch(function (err) {
            setEmailValidationError(err.errors.join());
        });
    }, [username]);
    var handleForgottenPassword = function () { return forgottenPassword(); };
    var handleEnterPress = function (event) {
        if (event.key === 'Enter')
            handleSubmit();
    };
    return ((0, jsx_runtime_1.jsxs)("form", __assign({ onSubmit: handleSubmit, className: classes.root }, { children: [(0, jsx_runtime_1.jsxs)("header", __assign({ className: classes.header }, { children: [icon, (0, jsx_runtime_1.jsx)("h1", __assign({ "data-testid": "title-text", className: classes.title }, { children: title })), !!subtitle && ((0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ "data-testid": "subtitle-text", className: classes.subtitle, component: "h2" }, { children: subtitle })))] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.field }, { children: (0, jsx_runtime_1.jsx)(TextField_1.TextField, { id: "username", name: "username", type: "string", label: "Email Address", value: state.username, onChange: function (_a) {
                        var target = _a.target;
                        return setState(__assign(__assign({}, state), { username: target.value }));
                    }, margin: "normal", onKeyUp: handleEnterPress, fullWidth: true, required: true, error: !!emailValidationError, helperText: emailValidationError }) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.field }, { children: (0, jsx_runtime_1.jsx)(atoms_1.PasswordToggleInput, { id: "sign-in-password", name: "password", label: "Password", buttonId: "ShowPasswordButton", defaultValue: state.password, onChange: function (_a) {
                        var target = _a.target;
                        return setState(__assign(__assign({}, state), { password: target.value }));
                    }, onKeyUp: handleEnterPress, required: true }) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.field }, { children: (0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ "data-testid": "lbl-login-error", className: classes.error }, { children: error || ' ' })) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.field }, { children: (0, jsx_runtime_1.jsx)(atoms_1.Checkbox, { label: rememberMeText, checked: state.remember, onChange: handleCheck, name: "RememberMeCheckbox", id: "RememberMeCheckbox", color: "primary", "data-testid": "chk-remember" }) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.field }, { children: (0, jsx_runtime_1.jsx)(Button_1.Button, __assign({ id: "sign-in-submit", color: "primary", variant: "contained", "data-testid": "btn-sign-in", disabled: !state.username || !state.password || !!emailValidationError, onClick: handleSubmit, fullWidth: true, loading: loading }, { children: "Sign In" })) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.centeredfield }, { children: (0, jsx_runtime_1.jsx)(core_1.Link, __assign({ role: "button", onClick: handleForgottenPassword }, { children: forgottenPasswordText })) })), !!footerText && ((0, jsx_runtime_1.jsx)("footer", __assign({ "data-testid": "footer-text", className: classes.footer }, { children: (0, jsx_runtime_1.jsx)(Text_1.Text, { children: footerText }) })))] })));
};
exports.SignIn = SignIn;
